import {useApi} from '@composables/useApi';
import {defineStore} from 'pinia';
import {AppChoose, AppInfo, FailedAuthError, HelpLink, SettingsInfo} from "@store/api/interfaces";
import {useAuthApi} from "@store/api/authApi";
//import * as Sentry from "@sentry/vue";

export const useSettingsApi = defineStore('settingsApi', () => {
	const authApi = useAuthApi();

	const getSettings = async (): Promise<SettingsInfo> => {
		try {
			return await useApi<SettingsInfo>('/settings', {
				method: "GET",
				headers: authApi.methods.getAuthHeaders()
			});
		} catch (error: any) {
			//Sentry.captureException(error);
			throw new FailedAuthError(error.message);
		}
	}
	const getApps = async (): Promise<AppInfo[]> => {
		try {
			return await useApi<AppInfo[]>('/settings/apps', {
				method: "GET",
				headers: authApi.methods.getAuthHeaders()
			});
		} catch (error: any) {
			//Sentry.captureException(error);
			throw new FailedAuthError(error.message);
		}
	}
	const getHelpLinks = async (): Promise<HelpLink[]> => {
		try {
			return await useApi<HelpLink[]>('/settings/help', {
				method: "GET",
				headers: authApi.methods.getAuthHeaders()
			});
		} catch (error: any) {
			//Sentry.captureException(error);
			throw new FailedAuthError(error.message);
		}
	}
	const getAppsChoose = async (): Promise<AppChoose[]> => {
		try {
			return await useApi<AppChoose[]>('/settings/user/app', {
				method: "GET",
				headers: authApi.methods.getAuthHeaders()
			});
		} catch (error: any) {
			//Sentry.captureException(error);
			throw new FailedAuthError(error.message);
		}
	}
	const saveAppChoose = async (params: AppChoose): Promise<AppChoose[]> => {
		try {
			return await useApi<AppChoose[]>('/settings/user/app', {
				method: "POST",
				headers: authApi.methods.getAuthHeaders(),
				body: JSON.stringify(params)
			});
		} catch (error: any) {
			//Sentry.captureException(error);
			throw new FailedAuthError(error.message);
		}
	}

	return {
		getSettings,
		getApps,
		getHelpLinks,
		getAppsChoose,
		saveAppChoose
	};
})
